import { usePubNub } from "pubnub-react";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import svgIcons from "../../../assets/svg/svgIcons";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import { APP_CONFIG } from "../../../constants/constants";
import { formattedDateTime } from "../../../utils/dateTime";
import { getUserIntials } from "../../../utils/string";
import ChatAvatar from "../../chat/components/chatAvatar";
import { EventComment } from "../../../api/types/CamerasAdminVM";
import { toZonedTime } from "date-fns-tz";
import { useAccountTimezone } from "../../../hooks/timezone";
import {
  localStorageKeys,
  useLocalStorage,
} from "../../../utils/localStorageItems";
import { useSelector } from "react-redux";
import { LegacyVerifyEmailOtpResponseSuccess } from "../../../api/types/Onboarding";
import { TLegacyUser } from "../../../api/types/User";

const getChatMessageTimeDisplay = (timetoken: number) => {
  const milliseconds = timetoken / 10000;
  const messageTime = new Date(milliseconds);
  const format = "LLL dd, yyyy h:mmaaa";
  if (messageTime.getDate() === new Date().getDate()) {
    // TODO: needs work
    return formattedDateTime(messageTime, format); //humanReadableTimeDuration(milliseconds, true);
  }
  return formattedDateTime(messageTime, format);
};

type TEventCommentMessageProps = {
  message: EventComment;
  messageClass?: string;
  wrapperClass?: string;
};

const EventCommentMessage: FC<TEventCommentMessageProps> = ({
  message,
  messageClass = "rounded-md text-heading-gray444 text-sm px-4 py-2",
  wrapperClass = "",
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.history.events.comments",
  });

  const { getLocalStorageItem } = useLocalStorage();
  const loggedInUserData = useSelector(
    (state: { commonReducer: { user: LegacyVerifyEmailOtpResponseSuccess } }) =>
      state.commonReducer.user
  );
  const loggedInUser: TLegacyUser =
    loggedInUserData?.user ?? getLocalStorageItem(localStorageKeys.user);

  const { convertToTZForDateFns, tzForDateFns } = useAccountTimezone();

  const senderId = "";
  // const senderMember = [message.customers_firstname, message.customers_lastname]
  //   .filter((item) => !!item)
  //   .join(" ");
  // 6/5/2025 above logic to identify sender member name is disabled
  // as we will be using the following workaround to keep track of sender
  // we prepend sender information in the message content
  const senderMember =
    message.content.match(/\[[!_a-zA-Z0-9]+\|\|[a-zA-Z0-9\s]+\]:/g) || null;
  const senderNameUserId =
    !!senderMember && !!senderMember?.[0]
      ? senderMember[0].replace("[", "").replace("]", "").replace(":", "")
      : null;
  const senderUserId =
    !!senderMember && !!senderMember?.[0] && !!senderNameUserId
      ? senderNameUserId.split("||")[0]
      : null;
  const senderName =
    !!senderMember && !!senderMember?.[0] && !!senderNameUserId
      ? senderNameUserId.split("||")[1]
      : null;

  const messageByMe = senderUserId === loggedInUser.userid;

  const avatarInitials =
    !!senderMember && !!senderMember?.[0] && !!senderName
      ? getUserIntials(senderName)
      : "?";

  const at_display_datetime = getChatMessageTimeDisplay(
    toZonedTime(
      new Date(message.created_at),
      convertToTZForDateFns(tzForDateFns)
    ).getTime() * 10000
  );

  return (
    <div
      className={`relative flex gap-2 items-start justify-start${messageByMe ? " flex-row-reverse" : ""} ${wrapperClass}`}
    >
      {/* Avatar */}
      {/* <AppAvatar
        bgColorClass={messageByMe
          ? 'bg-gray-300'
          : 'bg-accent-blue-pale'
        }
        extraClasses="flex-shrink-0"
        initials={avatarInitials}
      /> */}
      <ChatAvatar
        isMe={messageByMe || avatarInitials === "?"}
        title={avatarInitials}
      />

      {/* Message */}
      <span
        className={`relative flex flex-col mb-3 ${messageByMe ? "bg-gray-200" : "bg-accent-blue-pale"} ${messageClass}`}
      >
        {/* mb-3 to accommodate the date display */}
        {/* {
          typeof message.entry === 'string'
            ? message.entry
            : typeof (message.entry as TPubNubFile)?.message?.message === 'string'
              ? `${messageFileIsImage ? t('image') : t('file')}: ` + (message.entry as TPubNubFile)?.file?.name
              : typeof (message.entry as TPubNubTextMessage)?.message === 'string'
                ? (message.entry as TPubNubTextMessage)?.message
                : JSON.stringify((message.entry as TPubNubTextMessage)?.message)
        } */}
        {!!senderMember ? message.content.split("]:")[1] : message.content}
        <span
          className={`absolute text-[9px] top-full -mt-0.5 ${messageByMe ? "right-0" : "left-0"} text-black/60 whitespace-nowrap`}
        >
          {!!senderName
            ? t("at_date_by_name", {
                at: at_display_datetime,
                name: senderName,
              })
            : at_display_datetime}
        </span>
      </span>
    </div>
  );
};
export default EventCommentMessage;
